var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrint({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "print_1_",
    "data-name": "print (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 25.413 25.413",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_15595",
    "data-name": "Path 15595",
    d: "M20.119,6.353V4.236A4.236,4.236,0,0,0,15.883,0H9.53A4.236,4.236,0,0,0,5.294,4.236V6.353A5.3,5.3,0,0,0,0,11.648v5.294a5.3,5.3,0,0,0,5.294,5.294,3.177,3.177,0,0,0,3.177,3.177h8.471a3.177,3.177,0,0,0,3.177-3.177,5.3,5.3,0,0,0,5.294-5.294V11.648a5.3,5.3,0,0,0-5.294-5.294ZM7.412,4.236A2.118,2.118,0,0,1,9.53,2.118h6.353A2.118,2.118,0,0,1,18,4.236V6.353H7.412ZM18,22.236A1.059,1.059,0,0,1,16.942,23.3H8.471a1.059,1.059,0,0,1-1.059-1.059V18a1.059,1.059,0,0,1,1.059-1.059h8.471A1.059,1.059,0,0,1,18,18ZM23.3,16.942a3.177,3.177,0,0,1-3.177,3.177V18a3.177,3.177,0,0,0-3.177-3.177H8.471A3.177,3.177,0,0,0,5.294,18v2.118a3.177,3.177,0,0,1-3.177-3.177V11.648A3.177,3.177,0,0,1,5.294,8.471H20.119A3.177,3.177,0,0,1,23.3,11.648Z",
    fill: "#ff6036"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_15596",
    "data-name": "Path 15596",
    d: "M18.177,10H16.059a1.059,1.059,0,0,0,0,2.118h2.118a1.059,1.059,0,0,0,0-2.118Z",
    transform: "translate(0.883 0.589)",
    fill: "#ff6036"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.c68d8351bb9a4b29fb4896665b73343e.svg";
export { ForwardRef as ReactComponent };